module.exports = __webpack_public_path__ + "media/images/mcard-9b8e8205471e8ad4a615d5a522c47002.png";